import type { GaiaIndicatorStatus } from '@/components/design/base/GaiaStatusIndicator.vue';
import type { KanbanStateInDb } from '@/api';

/**
 * The board's two conventions, kept together because both are guesses the API
 * cannot answer.
 *
 * `KanbanStateInDb` carries no status or kind — a column is just a name and a
 * position, and an org may rename, add or remove any of them. So the status dot
 * is derived from position (the last column reads as the finished one, the one
 * before it as in-progress) and the auto-move note keys off the literal name
 * the backend pipeline uses. Both are cosmetic: getting them wrong changes a
 * dot's colour, never behaviour.
 */

/** The column the extraction pipeline moves items out of on its own. */
const AI_REVIEW_COLUMN_NAME = 'AI Review';

const AI_REVIEW_NOTE = 'Items that complete AI review will automatically move to the next column';

/** Dot colour for a column, by its position among the ones actually drawn. */
export function columnStatus(
  state: KanbanStateInDb,
  index: number,
  visibleCount: number
): GaiaIndicatorStatus {
  if (state.archive_state) return 'neutral';
  if (visibleCount > 0 && index === visibleCount - 1) return 'success';
  if (visibleCount > 1 && index === visibleCount - 2) return 'warning';
  return 'pending';
}

/** The header tooltip note, for the one column that moves its own items on. */
export function columnNote(state: KanbanStateInDb): string | undefined {
  return state.name === AI_REVIEW_COLUMN_NAME ? AI_REVIEW_NOTE : undefined;
}
